module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "HomeDialogDetail"
  }, [_c('div', {
    staticClass: "HomeDialogDetail-header"
  }, [_c('div', [_c('span', [_vm._v("首页浮窗")]), _vm._v(" "), (_vm.isDetail) ? _c('span', [_vm._v("详情")]) : _vm._e(), _vm._v(" "), (!_vm.isDetail && _vm.floatingId) ? _c('span', [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (!_vm.isDetail && !_vm.floatingId) ? _c('span', [_vm._v("新增")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("返回")]), _vm._v(" "), (!_vm.isDetail) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handelSubmit
    }
  }, [_vm._v("\n        保存\n      ")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.form,
      "label-width": "150px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "HomeDialogDetail-content"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "浮窗图片",
      "required": ""
    }
  }, [_c('UploadItems', {
    attrs: {
      "keys": "imgUrl",
      "urls": _vm.form.imgUrl,
      "readonly": _vm.isDetail,
      "tips": "200x200，格式为jpg、png、gif"
    },
    on: {
      "onUrls": _vm.onUrls
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "浮窗收起图",
      "required": ""
    }
  }, [_c('UploadItems', {
    attrs: {
      "keys": "retractImgUrl",
      "urls": _vm.form.retractImgUrl,
      "readonly": _vm.isDetail
    },
    on: {
      "onUrls": _vm.onUrls
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.floatingId) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "点击数"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "点击数",
      "readonly": ""
    },
    model: {
      value: (_vm.clockCount),
      callback: function($$v) {
        _vm.clockCount = $$v
      },
      expression: "clockCount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "状态",
      "readonly": ""
    },
    model: {
      value: (_vm.form.statusName),
      callback: function($$v) {
        _vm.$set(_vm.form, "statusName", $$v)
      },
      expression: "form.statusName"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "浮窗名称"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 20,
      "placeholder": "浮窗名称",
      "readonly": _vm.isDetail
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点击事件",
      "required": ""
    }
  }, [(_vm.isDetail) ? _c('div', [_vm._v("\n              " + _vm._s(_vm.form.jumpUrlFlag ? "跳转至URL" : "无跳转") + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isDetail) ? _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.form.jumpUrlFlag),
      callback: function($$v) {
        _vm.$set(_vm.form, "jumpUrlFlag", $$v)
      },
      expression: "form.jumpUrlFlag"
    }
  }, [_vm._v("\n              无跳转\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isDetail) ? _c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.form.jumpUrlFlag),
      callback: function($$v) {
        _vm.$set(_vm.form, "jumpUrlFlag", $$v)
      },
      expression: "form.jumpUrlFlag"
    }
  }, [_vm._v("\n              跳转至URL\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.jumpUrlFlag),
      expression: "form.jumpUrlFlag"
    }],
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的URL地址",
      "readonly": _vm.isDetail
    },
    model: {
      value: (_vm.form.jumpUrl),
      callback: function($$v) {
        _vm.$set(_vm.form, "jumpUrl", $$v)
      },
      expression: "form.jumpUrl"
    }
  })], 1), _vm._v(" "), (_vm.form.jumpUrlFlag === 1) ? _c('div', {
    staticClass: "popup-prompt-wrap"
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否弹窗提示",
      "required": ""
    }
  }, [(_vm.isDetail) ? _c('div', {
    staticClass: "popup-prompt-detail"
  }, [_c('span', [_vm._v(_vm._s(_vm.form.isPopup === 1 ? '是' : '否'))]), _vm._v(" "), (_vm.form.isPopup === 1) ? _c('span', {
    staticClass: "popup-prompt-detail-content"
  }, [_vm._v(_vm._s(_vm.form.popupContent))]) : _vm._e()]) : _c('div', {
    staticClass: "popup-prompt-row"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.isPopup),
      callback: function($$v) {
        _vm.$set(_vm.form, "isPopup", $$v)
      },
      expression: "form.isPopup"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), (_vm.form.isPopup === 1) ? _c('el-input', {
    staticClass: "popup-prompt-input",
    attrs: {
      "maxlength": "20",
      "placeholder": "请填写弹窗内容，最多20个字"
    },
    model: {
      value: (_vm.form.popupContent),
      callback: function($$v) {
        _vm.$set(_vm.form, "popupContent", $$v)
      },
      expression: "form.popupContent"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popup-prompt-example"
  }, [_c('span', {
    staticClass: "popup-prompt-example-label"
  }, [_vm._v("示例")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.popupPromptExampleImg,
      "alt": "弹窗示例"
    }
  })])], 1)])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "HomeDialogDetail-content border-none"
  }, [_c('SelectSchool', {
    attrs: {
      "schObj": _vm.form,
      "disabled": _vm.isDetail,
      "isRoot": false
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布时间",
      "required": ""
    }
  }, [(!_vm.isDetail) ? _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择发布时间"
    },
    model: {
      value: (_vm.form.startTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "startTime", $$v)
      },
      expression: "form.startTime"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDetail) ? _c('el-input', {
    staticClass: "formItems",
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.form.startTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "startTime", $$v)
      },
      expression: "form.startTime"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "失效时间"
    }
  }, [(!_vm.isDetail) ? _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择失效时间"
    },
    model: {
      value: (_vm.form.endTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "endTime", $$v)
      },
      expression: "form.endTime"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isDetail) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.form.endTime = ''
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })]) : _vm._e(), _vm._v(" "), (!_vm.isDetail) ? _c('span', [_vm._v("如不选，择默认不会自动失效")]) : _vm._e(), _vm._v(" "), (_vm.isDetail) ? _c('el-input', {
    staticClass: "formItems",
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.form.endTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "endTime", $$v)
      },
      expression: "form.endTime"
    }
  }) : _vm._e()], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-85f8e644!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/HomeDialog/detail.vue
// module id = 1097
// module chunks = 0